// extracted by mini-css-extract-plugin
export default {"box":"BorderedBox_box__014t8","borderBoxSecondary":"BorderedBox_borderBoxSecondary__dcVuK"};